import IconButton from '@/components/common/IconButton';
import CancelIcon from '@mui/icons-material/Cancel';
import SaveIcon from '@mui/icons-material/Save';
import { Stack, TextField } from '@mui/material';
import { FC, useState } from 'react';
import { UserEventItem } from './UserEventsManager';

type UserEventListItemEditProps = {
  userEvent?: UserEventItem;
  onClose: (isEmpty?: boolean) => void;
  onSave: (newUserEvent: UserEventItem) => void;
};

const UserEventListItemEdit: FC<UserEventListItemEditProps> = (props) => {
  const [userEvent, setUserEvent] = useState(props.userEvent?.event || '');
  const [userLabel, setUserLabel] = useState(props.userEvent?.label || '');
  const valid = !!userEvent;

  const handleClose = (isEmpty?: boolean) => {
    setUserEvent('');
    props.onClose(isEmpty);
  };

  return (
    <Stack
      direction='row'
      gap={1}
      pt={1}
      width='100%'
      alignItems='flex-start'
      alignContent='flex-start'
      bgcolor='action.focus'
      borderRadius={2}
      p={1}
    >
      <Stack gap={1} flexGrow={2} width='100%'>
        <TextField
          label='User Event'
          value={userEvent}
          onChange={(event) => setUserEvent(event.currentTarget.value.trim())}
          fullWidth
          size='small'
          autoFocus
          required
          InputProps={{ autoComplete: 'off' }}
        />
      </Stack>
      <TextField
        label='User Label'
        value={userLabel}
        onChange={(event) => setUserLabel(event.currentTarget.value)}
        fullWidth
        size='small'
        InputProps={{ autoComplete: 'off' }}
      />
      <IconButton
        tooltip={valid ? 'Save' : undefined}
        disabled={!valid}
        onClick={() => {
          if (!valid) return;
          const newUserEvent: UserEventItem = {
            event: userEvent,
            label: userLabel
          };
          props.onSave(newUserEvent);
          handleClose();
        }}
      >
        <SaveIcon />
      </IconButton>
      <IconButton tooltip='Cancel' onClick={() => handleClose(!props.userEvent?.event)}>
        <CancelIcon />
      </IconButton>
    </Stack>
  );
};

export default UserEventListItemEdit;
